const OPEN_TIMEOUT_POPUP = 'OPEN_TIMEOUT_POPUP';
const CLOSE_TIMEOUT_POPUP = 'CLOSE_TIMEOUT_POPUP';

function openTimeoutPopup() {
  // return (dispatch, getStore) => {
  //   const isOpen = getStore().timer.timeout_popup;
  //
  //   if(!isOpen) dispatch({
  //     type: OPEN_TIMEOUT_POPUP,
  //     payload: true
  //   })
  // };

  return {
    type: OPEN_TIMEOUT_POPUP,
    payload: true
  }
}

function closeTimeoutPopup() {
  return {
    type: CLOSE_TIMEOUT_POPUP,
    payload: false
  }
}

export {
  openTimeoutPopup,
  closeTimeoutPopup
}

const initialState = {
  timeout_popup: false
};

const ACTION_HANDLERS = {
  [OPEN_TIMEOUT_POPUP]: (state, action) => ({
    ...state,
    timeout_popup: action.payload
  }),
  [CLOSE_TIMEOUT_POPUP]: (state, action) => ({
    ...state,
    timeout_popup: action.payload
  }),
};


export default function timerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state
}


// WEBPACK FOOTER //
// ./src/store/timer.js